import { FC, useEffect, useState } from 'react';

import { SigninFormData, SigninMfaFormData } from 'types/form';
import { Layout } from 'components/layout/Layout';
import { useSharedStore } from 'stores/shared-store';
import Location from 'services/Location';

import { MFAForm } from './MFAForm';
import { SignInForm } from './SigninForm';

export const Signin: FC = () => {
  const sharedStore = useSharedStore(['email']);

  const [formData, setFormData] = useState<SigninFormData>({});
  const [mfaData, setMfaData] = useState<SigninMfaFormData>({
    mfa_token: Location.getUrlParam('mfa_token'),
  });

  const isNewSignin = Location.getUrlParam('new_signin') === '1';
  const isConflict = Location.getUrlParam('identity_exception') === 'conflict';
  const clientId = Location.getUrlParam('client_id');
  const isRequestAccessWrongAccountRedirect =
    Location.getUrlParam('signin_redirect') === 'request_access_wrong_account';

  useEffect(() => {
    setFormData((prevState) => ({ ...prevState, email: sharedStore.get('email') as string }));
  }, []);

  const handleFormDataChange = (data: SigninFormData) => {
    setFormData(data);

    if (data.email === undefined) {
      sharedStore.delete('email');
    } else {
      sharedStore.set({ email: data.email });
    }
  };

  const handleMFADataChange = (data: SigninMfaFormData) => {
    setMfaData(data);
  };

  const handleClearMFAData = () => {
    setMfaData({
      mfa_token: '',
    });
  };

  const handleClearRequestAccessRedirect = () => {
    window.location.href = '/';
  };

  if (mfaData.mfa_token) {
    return (
      <Layout showHeaderLogo showGoToSignIn onActionClick={handleClearMFAData}>
        <MFAForm formData={mfaData} onDataChange={handleMFADataChange} />
      </Layout>
    );
  }

  if (isNewSignin || isConflict) {
    return (
      <Layout
        showHeaderLogo
        showNewAccountAction={!isRequestAccessWrongAccountRedirect}
        showGoToSignIn={isRequestAccessWrongAccountRedirect}
        onActionClick={handleClearRequestAccessRedirect}
      >
        <SignInForm
          formData={formData}
          onDataChange={handleFormDataChange}
          isLegacy={false}
          isRequestAccessWrongAccountRedirect={isRequestAccessWrongAccountRedirect}
        />
      </Layout>
    );
  }

  return (
    <Layout
      showHeaderLogo
      showGoToSignIn={isRequestAccessWrongAccountRedirect}
      showGoToSignUp={
        clientId !== import.meta.env.VITE_APP_CONTEXT_EVENT_CLIENT_ID &&
        !isRequestAccessWrongAccountRedirect
      }
      onActionClick={handleClearRequestAccessRedirect}
    >
      <SignInForm
        formData={formData}
        onDataChange={handleFormDataChange}
        isLegacy
        isRequestAccessWrongAccountRedirect={isRequestAccessWrongAccountRedirect}
      />
    </Layout>
  );
};
